@if (!!(isLoading$ | async)) {
  <div class="d-flex flex-column justify-content-center align-items-center h-100">
    <app-loading></app-loading>
  </div>
} @else {
  <div class="d-flex gap-4 flex-column h-100">
    <ul ngbNav [activeId]="route.fragment | async" class="rmv-tabs">
      <li class="rmv-tabs__item" ngbNavItem="details" routerLinkActive="--active">
        <a class="rmv-tabs__link" ngbNavLink [routerLink]="['details']" queryParamsHandling="merge">Details</a>
      </li>
      @if ((scope$ | async) === 'external') {
        <li class="rmv-tabs__item" ngbNavItem="details" routerLinkActive="--active">
          <a class="rmv-tabs__link" ngbNavLink [routerLink]="['wo']" queryParamsHandling="merge">Work Orders</a>
        </li>
      }
      @if (showPhotos()) {
        <li class="rmv-tabs__item" ngbNavItem="photos" routerLinkActive="--active">
          <a class="rmv-tabs__link" ngbNavLink [routerLink]="['photos']" queryParamsHandling="merge">Photos</a>
        </li>
      }
    </ul>
    <div class="flex-fill">
      <router-outlet></router-outlet>
    </div>
  </div>
}
